import React from 'react';
import { format } from 'date-fns';
import './styles/MeetingsListView.css';

const normalizeStatus = (status) => String(status || 'pending')
  .trim()
  .toLowerCase()
  .replace(/[_\s-]+/g, ' ');

const getStatusClass = (normalizedStatus) => {
  if (normalizedStatus === 'confirmed') return 'confirmed';
  if (normalizedStatus === 'cancelled') return 'cancelled';
  if (normalizedStatus === 'completed') return 'completed';
  return 'pending';
};

const formatDateTime = (date) => {
  if (!date) return 'No date specified';
  try {
    const dateObj = date.toDate ? date.toDate() : new Date(date);
    return format(dateObj, 'PPp');
  } catch {
    return 'Invalid date';
  }
};

const MeetingsListView = ({ meetings, onMeetingClick }) => (
  <div className="meetings-list-view" role="list">
    {meetings.map((meeting) => {
      const normalizedStatus = normalizeStatus(meeting.status);
      const statusClass = getStatusClass(normalizedStatus);
      const extraCount = meeting.additionalClients?.length || 0;
      const withLine =
        extraCount > 0
          ? `With ${meeting.clientName || 'Client'} + ${extraCount} other${extraCount > 1 ? 's' : ''}`
          : `With ${meeting.clientName || 'Client'}`;
      const meetingTypeLabel =
        (meeting.meetingType || 'one_on_one') === 'group' ? 'Group meeting' : 'One on One';

      return (
        <button
          key={meeting.id}
          type="button"
          className={`meetings-list-view__row meetings-list-view__row--${statusClass}`}
          onClick={() => onMeetingClick?.(meeting)}
          role="listitem"
        >
          <div className="meetings-list-view__main">
            <div className="meetings-list-view__title-row">
              <h3 className="meetings-list-view__title">{meeting.title || 'Meeting'}</h3>
            </div>
            <p className="meetings-list-view__subtitle">{withLine}</p>
          </div>

          <div className="meetings-list-view__meta">
            <span className="meetings-list-view__meta-primary">{formatDateTime(meeting.dateTime)}</span>
            <span className="meetings-list-view__meta-secondary">{meetingTypeLabel}</span>
          </div>
        </button>
      );
    })}
  </div>
);

export default React.memo(MeetingsListView);
